import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@app/_services/common.service';

@Component({
  selector: 'app-format-data',
  templateUrl: './format-data.component.html',
  styleUrls: ['./format-data.component.less']
})
export class FormatDataComponent implements OnInit {
  fileUploadForm: FormGroup;
  selectedFile: File | null = null;


  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.fileUploadForm = new FormGroup({
      selectedOption: new FormControl('', Validators.required),
      fileInput: new FormControl('', Validators.required)
    });
   this.fetchSAllFormDetails();
  }
  fetchSAllFormDetails() {
   this.commonService.fetchAllFormDetails().subscribe((res)=>{
    
   });
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0] || null;

    this.selectedFile = file;
    this.fileUploadForm.get('fileInput')?.setValue(file || ''); // Update the form control
  }

  onSubmit(): void {
    if (this.fileUploadForm.valid && this.selectedFile) {
      let id=1;
      this.commonService.uploadFile(this.selectedFile,id).subscribe({
        next: (res) => console.log('File uploaded successfully:', res),
        error: (err) => console.error('Error uploading file:', err),
      });
    }
  }

  cancelFile(): void {
    this.selectedFile = null; // Clear the selected file
  }
}
